module.exports = __webpack_public_path__ + "media/images/weather/204_day-857b9dc23eec654a240725b89277110c.png";